(function () {
  function sentence(text) {
    text = (text || '').replace(/\s+/g, ' ').trim();
    if (!text || /(detox|immun|vitamin|antioxid|kalori|energi|boost|allerg|hud|hår|hälsa|inflammation|metabolism|fett|vikt|stärker)/i.test(text)) return '';
    var lower = text.toLocaleLowerCase('sv-SE');
    return lower.charAt(0).toLocaleUpperCase('sv-SE') + lower.slice(1);
  }

  function adoptLabels(card) {
    var nodes = card.querySelectorAll('[class*="_lably"]');
    if (!nodes.length) return;
    var anchor = card.querySelector('a.lazy-image') || card;
    var seen = {};
    anchor.querySelectorAll('.kp-badge').forEach(function (badge) {
      seen[badge.textContent.trim().toLocaleLowerCase('sv-SE')] = true;
    });
    nodes.forEach(function (node) {
      var label = sentence(node.textContent);
      if (!label) return;
      var key = label.toLocaleLowerCase('sv-SE');
      if (seen[key]) return;
      seen[key] = true;
      var span = document.createElement('span');
      span.className = 'kp-badge';
      span.textContent = label;
      anchor.appendChild(span);
    });
    anchor.querySelectorAll('.kp-badge').forEach(function (badge, index) {
      badge.style.top = (12 + index * 28) + 'px';
    });
    card.setAttribute('data-kp-labels', 'done');
  }

  function scanLabels() {
    document.querySelectorAll('.product-grid-item').forEach(adoptLabels);
  }

  var motionObserver;

  function revealImmediately(items) {
    items.forEach(function (item) {
      item.classList.add('kp-reveal', 'is-visible');
    });
  }

  function scanMotion() {
    var selectors = [
      '.kp [data-kp-reveal]',
      '.kp .kp__center',
      '.kp-ben__card',
      '.kp-ti__media',
      '.kp-ti__text',
      '.kp-step',
      '.kp-q',
      '.kp-band',
      '.kp-collection-guide [data-kp-reveal]',
      '.template-collection .product-grid-item',
      '.template-product .product__photo',
      '.template-product .product__details'
    ].join(',');
    var items = Array.prototype.slice.call(document.querySelectorAll(selectors)).filter(function (item) {
      return !item.classList.contains('kp-reveal');
    });
    if (!items.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      revealImmediately(items);
      return;
    }
    if (!motionObserver) {
      motionObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          motionObserver.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    items.forEach(function (item, index) {
      item.classList.add('kp-reveal');
      item.style.setProperty('--kp-delay', Math.min(index % 4, 3) * 70 + 'ms');
      motionObserver.observe(item);
    });
  }

  function animateHero() {
    var hero = document.querySelector('.kpf');
    if (!hero || hero.classList.contains('kp-motion-ready')) return;
    hero.classList.add('kp-motion-ready');
    window.requestAnimationFrame(function () {
      hero.classList.add('is-visible');
    });
  }

  function money(cents) {
    var amount = Math.round(cents / 100);
    return amount.toLocaleString('sv-SE') + ' kr';
  }

  function imageSrc(product) {
    var image = product.featured_image;
    if (!image) return '';
    if (typeof image === 'string') return image;
    return image.src || image.url || '';
  }

  function isFast(title) {
    var text = (title || '').toLocaleLowerCase('sv-SE');
    return text.indexOf('juicefasta') !== -1 || text.indexOf('dagar') !== -1 || text.indexOf('prova') !== -1;
  }

  var cache = { signature: '', html: '' };
  var inflight = null;

  function cartSignature(cart) {
    var ids = {};
    (cart.items || []).forEach(function (item) { ids[item.product_id] = true; });
    return Object.keys(ids).sort().join(',');
  }

  function rootSignature(root) {
    return (root.getAttribute('data-kp-ids') || '').split(',').filter(Boolean).sort().join(',');
  }

  function cardsHtml(picks) {
    var grid = document.createElement('div');
    picks.forEach(function (pick) {
      var product = pick.product;
      var variant = pick.variant;
      var card = document.createElement('div');
      card.className = 'kp-upsell__card';
      var link = document.createElement('a');
      link.href = product.url;
      var image = document.createElement('img');
      image.alt = product.title;
      image.src = imageSrc(product);
      var name = document.createElement('span');
      name.className = 'kp-upsell__name';
      name.textContent = product.title;
      link.appendChild(image);
      link.appendChild(name);
      var price = document.createElement('span');
      price.className = 'kp-upsell__price';
      price.textContent = money(variant.price);
      var add = document.createElement('a');
      add.className = 'kp-upsell__add';
      add.href = '/cart/add?id=' + variant.id + '&quantity=1';
      add.textContent = 'Lägg till';
      card.appendChild(link);
      card.appendChild(price);
      card.appendChild(add);
      grid.appendChild(card);
    });
    return grid.innerHTML;
  }

  function paint(root, html) {
    if (!root) return;
    var grid = root.querySelector('.kp-upsell__grid');
    if (!grid) return;
    if (grid.innerHTML !== html) grid.innerHTML = html;
    root.hidden = !html;
    root.setAttribute('data-kp-ready', '1');
  }

  function build(cart) {
    var inCart = {};
    (cart.items || []).forEach(function (item) { inCart[item.product_id] = item; });
    var ids = Object.keys(inCart);
    var signature = ids.slice().sort().join(',');
    if (!ids.length) return Promise.resolve({ signature: signature, html: '' });
    var cartHasFast = (cart.items || []).some(function (item) { return isFast(item.product_title); });
    var gap = 120000 - cart.total_price;
    return Promise.all(ids.slice(0, 4).map(function (id) {
      return fetch('/recommendations/products.json?product_id=' + id + '&limit=8&intent=related')
        .then(function (response) { return response.json(); })
        .then(function (data) { return data.products || []; })
        .catch(function () { return []; });
    })).then(function (lists) {
      var scores = {};
      lists.forEach(function (products) {
        products.forEach(function (product) {
          if (inCart[product.id] || product.available === false) return;
          var variant = (product.variants || []).filter(function (item) { return item.available; })[0];
          if (!variant) return;
          if (!scores[product.id]) scores[product.id] = { product: product, variant: variant, score: 0 };
          scores[product.id].score += 2;
          if (cartHasFast && isFast(product.title)) scores[product.id].score -= 3;
          if (gap > 0 && variant.price >= gap && variant.price <= gap + 40000) {
            scores[product.id].score += 2;
          } else if (gap > 0 && variant.price > 0 && variant.price < gap) {
            scores[product.id].score += 1;
          }
        });
      });
      var picks = Object.keys(scores).map(function (id) { return scores[id]; });
      picks.sort(function (a, b) { return b.score - a.score || a.product.title.localeCompare(b.product.title, 'sv'); });
      return { signature: signature, html: cardsHtml(picks.slice(0, 3)) };
    });
  }

  function ensure(cart) {
    var signature = cartSignature(cart);
    if (cache.signature === signature) return Promise.resolve(cache);
    if (inflight && inflight.signature === signature) return inflight.promise;
    var promise = build(cart).then(function (result) {
      if (!inflight || inflight.signature === signature) cache = result;
      if (inflight && inflight.signature === signature) inflight = null;
      return result;
    }).catch(function () {
      if (inflight && inflight.signature === signature) inflight = null;
      return { signature: signature, html: '' };
    });
    inflight = { signature: signature, promise: promise };
    return promise;
  }

  function mount(root) {
    if (!root || root.getAttribute('data-kp-ready') === '1') return;
    var signature = rootSignature(root);
    if (cache.signature === signature) {
      paint(root, cache.html);
      return;
    }
    if (root.getAttribute('data-kp-loading') === '1') return;
    root.setAttribute('data-kp-loading', '1');
    var pending = (inflight && inflight.signature === signature)
      ? inflight.promise
      : fetch('/cart.js', { cache: 'no-store' }).then(function (response) { return response.json(); }).then(ensure);
    pending.then(function (result) {
      var live = root.isConnected ? root : document.querySelector('[data-kp-upsell]');
      if (!live || rootSignature(live) !== result.signature) return;
      paint(live, result.html);
    }).catch(function () {
      root.removeAttribute('data-kp-loading');
    });
  }

  document.addEventListener('theme:cart:change', function (event) {
    if (!document.querySelector('[data-kp-upsell]') || !event.detail || !event.detail.cart) return;
    ensure(event.detail.cart);
  });

  var labelQueued;
  function scheduleLabels() {
    clearTimeout(labelQueued);
    labelQueued = setTimeout(function () {
      scanLabels();
      scanMotion();
    }, 80);
  }

  function hideDefaultTitle() {
    document.querySelectorAll('.selector-wrapper, .radio__fieldset, .select__fieldset').forEach(function (el) {
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (/default title/i.test(text)) el.classList.add('kp-variant-hidden');
    });
  }

  function boot() {
    scanLabels();
    scanMotion();
    animateHero();
    hideDefaultTitle();
    document.querySelectorAll('[data-kp-upsell]').forEach(mount);
    var wrapper = document.querySelector('[data-cart-form-wrapper]');
    if (!wrapper) return;
    new MutationObserver(function () {
      var root = wrapper.querySelector('[data-kp-upsell]');
      if (root) mount(root);
    }).observe(wrapper, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  new MutationObserver(function (mutations) {
    var relevant = mutations.some(function (mutation) {
      var node = mutation.target;
      return !(node.closest && node.closest('[data-cart-form-wrapper]'));
    });
    if (relevant) scheduleLabels();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
